import styled from 'styled-components';

import { StyledDefaultTableBodyRow } from '../../../../../cdl/TableBuilder/components/StyledDefaultTableBodyRow';
import { Text } from '../../../../../cdl/Text/Text';
import { translate } from '../../../../../common/helpers/translate.helper';
import { Box } from '../../../../../common/ui/Box';
import { theme } from '../../../../../common/ui/theme';
import { stickyProductColumnStyles } from '../stickyProductColumnStyles';
import { TotalCellContent } from '../TotalCellContent';
import type { LineItemComparisonTotalCell } from '../types/LineItemComparisonTotalCell';

const TotalCell = styled.td`
    border-top: 2px solid ${theme.colors.background.inset};
    padding: ${theme.space[12]} calc(${theme.space[16]} + ${theme.space[6]}) ${theme.space[12]} ${theme.space[16]};
    text-align: right;
    vertical-align: top;
`;

const TotalLabelCell = styled(TotalCell)<{ $showScrollShadow: boolean }>`
    ${stickyProductColumnStyles};
    z-index: 1;
    background-color: ${theme.colors.background.default};
    padding-right: ${theme.space[16]};
    text-align: left;

    tr:nth-child(odd) & {
        background-color: ${theme.colors.background.subtle};
    }
`;

interface LineItemComparisonTotalRowProps {
    totals: LineItemComparisonTotalCell[];
    showScrollShadow: boolean;
}

export const LineItemComparisonTotalRow = ({ totals, showScrollShadow }: LineItemComparisonTotalRowProps) => {
    return (
        <StyledDefaultTableBodyRow active={false} selectable={false} alternateRowColors grow>
            <TotalLabelCell $showScrollShadow={showScrollShadow}>
                <Box display="grid" rowGap={2} justifyItems="start">
                    <Text fontWeight={600}>{translate('global.total')}</Text>
                </Box>
            </TotalLabelCell>
            {totals.map((totalCell) => (
                <TotalCell key={totalCell.offerId}>
                    <TotalCellContent
                        total={totalCell.total}
                        ppl={totalCell.ppl}
                        offeredVolume={totalCell.offeredVolume}
                    />
                </TotalCell>
            ))}
        </StyledDefaultTableBodyRow>
    );
};
